export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categoryName: string;
  cover: string;
  description: string;
  rating: number;
  views: number;
  tags: string[];
  status: string;
  updatedAt: string;
  chapters: Chapter[];
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
}

export const categories = [
  { id: "c1", name: "恋爱言情", slug: "romance", count: 128 },
  { id: "c2", name: "奇幻冒险", slug: "fantasy", count: 96 },
  { id: "c3", name: "悬疑推理", slug: "mystery", count: 54 },
  { id: "c4", name: "动作热血", slug: "action", count: 87 },
  { id: "c5", name: "都市生活", slug: "urban", count: 72 },
  { id: "c6", name: "搞笑日常", slug: "comedy", count: 63 },
  { id: "c7", name: "恐怖惊悚", slug: "horror", count: 31 },
  { id: "c8", name: "古风穿越", slug: "historical", count: 45 },
  { id: "c9", name: "科幻未来", slug: "scifi", count: 38 },
  { id: "c10", name: "BL/GL", slug: "bl-gl", count: 56 },
];

export const comics = [
  {
    id: "comic-1",
    title: "我被困在游戏里的一千年",
    author: "金志浩",
    category: "fantasy",
    categoryName: "奇幻冒险",
    cover: "https://readdy.ai/api/search-image?query=A%20visually%20striking%20Korean%20manhwa%20style%20cover%20art%20with%20a%20male%20protagonist%20holding%20a%20glowing%20sword%20in%20a%20fantasy%20game%20world%2C%20dramatic%20lighting%20with%20warm%20golden%20and%20amber%20tones%2C%20manga%20art%20style%2C%20high%20detail%20digital%20illustration%2C%20soft%20gradient%20background%20with%20ethereal%20particles%2C%20professional%20anime%20cover%20quality%2C%20clean%20composition%20with%20dynamic%20pose&width=800&height=1100&seq=manhwa-cover-01&orientation=portrait",
    description: "普通大学生李贤宇意外进入了一款神秘的虚拟现实游戏，被困在游戏世界中长达一千年。在这漫长的岁月里，他从一个弱小的新手成长为传奇级别的存在。当他终于找到回归现实的方法时，却发现现实世界只过去了一天。带着游戏中积累的惊人能力和知识，他的人生从此彻底改变。",
    rating: 4.8,
    views: 2356000,
    tags: ["系统流", "游戏", "逆袭", "热血"],
    status: "连载中",
    updatedAt: "2026-08-04",
    chapters: [
      { id: "ch1-1", title: "第1话 游戏开始", number: 1 },
      { id: "ch1-2", title: "第2话 新手村的秘密", number: 2 },
      { id: "ch1-3", title: "第3话 第一次战斗", number: 3 },
      { id: "ch1-4", title: "第4话 隐藏职业", number: 4 },
      { id: "ch1-5", title: "第5话 公会邀请", number: 5 },
      { id: "ch1-6", title: "第6话 深渊副本", number: 6 },
      { id: "ch1-7", title: "第7话 传说级武器", number: 7 },
      { id: "ch1-8", title: "第8话 最终BOSS", number: 8 },
      { id: "ch1-9", title: "第9话 回归现实", number: 9 },
      { id: "ch1-10", title: "第10话 新的开始", number: 10 },
    ],
  },
  {
    id: "comic-2",
    title: "社内恋爱禁止令",
    author: "李恩雅",
    category: "romance",
    categoryName: "恋爱言情",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20romance%20cover%20art%20featuring%20a%20stylish%20young%20woman%20in%20office%20attire%20and%20a%20handsome%20man%20in%20a%20suit%20standing%20close%20together%20with%20soft%20romantic%20atmosphere%2C%20cherry%20blossom%20petals%20floating%2C%20warm%20pink%20and%20peach%20color%20palette%2C%20modern%20office%20building%20in%20background%2C%20delicate%20manga%20art%20style%2C%20professional%20shoujo%20cover%20quality%2C%20clean%20and%20elegant%20composition&width=800&height=1100&seq=manhwa-cover-02&orientation=portrait",
    description: "在韩国最大的娱乐公司，有一条不成文的规定——绝对禁止办公室恋情。但当新入职的策划部职员韩素熙遇见了她的直属上司、公司最年轻的理事姜泰俊时，一切都开始失控。两人在无数次的工作摩擦中逐渐产生了微妙的情感，却不得不在众人面前装作毫无关系。一场甜蜜又危险的秘密恋爱开始了。",
    rating: 4.6,
    views: 1890000,
    tags: ["办公室", "甜蜜", "总裁", "都市"],
    status: "连载中",
    updatedAt: "2026-08-05",
    chapters: [
      { id: "ch2-1", title: "第1话 入职第一天", number: 1 },
      { id: "ch2-2", title: "第2话 魔鬼上司", number: 2 },
      { id: "ch2-3", title: "第3话 加班夜", number: 3 },
      { id: "ch2-4", title: "第4话 意外的吻", number: 4 },
      { id: "ch2-5", title: "第5话 心跳加速", number: 5 },
      { id: "ch2-6", title: "第6话 地下恋情", number: 6 },
      { id: "ch2-7", title: "第7话 危机来临", number: 7 },
      { id: "ch2-8", title: "第8话 真心告白", number: 8 },
    ],
  },
  {
    id: "comic-3",
    title: "暗夜追踪者",
    author: "朴振宇",
    category: "mystery",
    categoryName: "悬疑推理",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20and%20moody%20Korean%20manhwa%20mystery%20thriller%20cover%20featuring%20a%20detective%20in%20a%20trench%20coat%20standing%20under%20a%20streetlamp%20in%20rainy%20Seoul%20alleyway%2C%20noir%20atmosphere%20with%20deep%20shadows%20and%20dramatic%20lighting%2C%20cool%20dark%20blue%20and%20gray%20tones%2C%20suspenseful%20mood%2C%20detailed%20urban%20background%2C%20mature%20manga%20art%20style%2C%20professional%20seinen%20cover%20quality%2C%20cinematic%20composition&width=800&height=1100&seq=manhwa-cover-03&orientation=portrait",
    description: "首尔连续发生了多起离奇失踪案件，所有线索都指向一个神秘的暗网组织。前刑警金道贤在追查妹妹失踪的真相时，发现了一个令人毛骨悚然的秘密——这些失踪者都与一个名为「暗夜」的秘密实验有关。每一步都充满了危险和反转，真相远比想象中更加黑暗。",
    rating: 4.9,
    views: 3120000,
    tags: ["悬疑", "犯罪", "推理", "都市"],
    status: "连载中",
    updatedAt: "2026-08-03",
    chapters: [
      { id: "ch3-1", title: "第1话 失踪", number: 1 },
      { id: "ch3-2", title: "第2话 第一个线索", number: 2 },
      { id: "ch3-3", title: "第3话 暗网", number: 3 },
      { id: "ch3-4", title: "第4话 证人", number: 4 },
      { id: "ch3-5", title: "第5话 追踪", number: 5 },
      { id: "ch3-6", title: "第6话 真相浮现", number: 6 },
      { id: "ch3-7", title: "第7话 致命陷阱", number: 7 },
      { id: "ch3-8", title: "第8话 绝地反击", number: 8 },
    ],
  },
  {
    id: "comic-4",
    title: "剑圣归来",
    author: "崔武烈",
    category: "action",
    categoryName: "动作热血",
    cover: "https://readdy.ai/api/search-image?query=An%20epic%20Korean%20manhwa%20action%20cover%20art%20with%20a%20powerful%20warrior%20wielding%20a%20massive%20sword%20surrounded%20by%20martial%20arts%20energy%20effects%2C%20dramatic%20dynamic%20composition%20with%20flying%20debris%2C%20intense%20warm%20red%20and%20orange%20battle%20atmosphere%2C%20mountainous%20landscape%20background%2C%20fierce%20expression%2C%20detailed%20armor%20design%2C%20high%20quality%20action%20manga%20style%2C%20professional%20shonen%20cover%20quality&width=800&height=1100&seq=manhwa-cover-04&orientation=portrait",
    description: "传说中的剑圣独孤云在击败魔教教主后神秘消失，武林以为他已经陨落。二十年后，一个看似普通的少年在偏远山村中苏醒，他体内沉睡着剑圣的灵魂。当魔教余孽再次威胁武林时，剑圣归来，一场惊天动地的武侠传奇就此展开。",
    rating: 4.7,
    views: 2780000,
    tags: ["武侠", "重生", "热血", "战斗"],
    status: "连载中",
    updatedAt: "2026-08-02",
    chapters: [
      { id: "ch4-1", title: "第1话 山村少年", number: 1 },
      { id: "ch4-2", title: "第2话 剑圣觉醒", number: 2 },
      { id: "ch4-3", title: "第3话 初入江湖", number: 3 },
      { id: "ch4-4", title: "第4话 魔教来袭", number: 4 },
      { id: "ch4-5", title: "第5话 名剑大会", number: 5 },
      { id: "ch4-6", title: "第6话 宿命对决", number: 6 },
    ],
  },
  {
    id: "comic-5",
    title: "咖啡店老板的日常",
    author: "郑秀敏",
    category: "urban",
    categoryName: "都市生活",
    cover: "https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20Korean%20manhwa%20slice%20of%20life%20cover%20art%20showing%20a%20young%20barista%20in%20a%20quaint%20coffee%20shop%20interior%20with%20warm%20lighting%2C%20steaming%20coffee%20cups%20and%20pastries%2C%20soft%20golden%20hour%20sunlight%20streaming%20through%20windows%2C%20gentle%20and%20inviting%20atmosphere%2C%20detailed%20cafe%20background%20with%20bookshelves%20and%20plants%2C%20heartwarming%20manga%20art%20style%2C%20professional%20slice%20of%20life%20cover%20quality%2C%20relaxed%20composition&width=800&height=1100&seq=manhwa-cover-05&orientation=portrait",
    description: "在首尔弘大附近的一条安静小巷里，有一家名为「慢时光」的咖啡店。老板金智浩每天都会遇到形形色色的客人——失恋的上班族、追梦的音乐人、迷茫的大学生。通过一杯杯咖啡和温暖的对话，他倾听着每个人的故事，也在这个过程中找到了自己人生的意义。",
    rating: 4.4,
    views: 890000,
    tags: ["治愈", "日常", "咖啡", "温暖"],
    status: "已完结",
    updatedAt: "2026-07-28",
    chapters: [
      { id: "ch5-1", title: "第1话 开店第一天", number: 1 },
      { id: "ch5-2", title: "第2话 第一位客人", number: 2 },
      { id: "ch5-3", title: "第3话 雨天", number: 3 },
      { id: "ch5-4", title: "第4话 老友重逢", number: 4 },
      { id: "ch5-5", title: "第5话 新的旅程", number: 5 },
    ],
  },
  {
    id: "comic-6",
    title: "搞笑一家人之异世界篇",
    author: "韩泰俊",
    category: "comedy",
    categoryName: "搞笑日常",
    cover: "https://readdy.ai/api/search-image?query=A%20colorful%20and%20funny%20Korean%20manhwa%20comedy%20cover%20art%20showing%20a%20chaotic%20family%20in%20fantasy%20costumes%20making%20exaggerated%20funny%20expressions%2C%20bright%20vibrant%20colors%20with%20cartoonish%20effects%2C%20fantasy%20castle%20background%20with%20comedic%20elements%2C%20lively%20and%20energetic%20atmosphere%2C%20expressive%20manga%20art%20style%2C%20professional%20comedy%20cover%20quality%2C%20dynamic%20group%20composition&width=800&height=1100&seq=manhwa-cover-06&orientation=portrait",
    description: "普通的一家四口在某天早上醒来，发现自己竟然穿越到了剑与魔法的异世界！爸爸成了魔法师，妈妈是圣骑士，哥哥变成了盗贼，而还在上小学的妹妹居然成了大魔王？这一家子如何在异世界闹出各种笑料，又能否找到回家的路？全程高能笑点不断！",
    rating: 4.5,
    views: 1560000,
    tags: ["搞笑", "穿越", "家庭", "异世界"],
    status: "连载中",
    updatedAt: "2026-08-04",
    chapters: [
      { id: "ch6-1", title: "第1话 早上好异世界", number: 1 },
      { id: "ch6-2", title: "第2话 勇者面试", number: 2 },
      { id: "ch6-3", title: "第3话 讨伐哥布林", number: 3 },
      { id: "ch6-4", title: "第4话 魔王妹妹", number: 4 },
      { id: "ch6-5", title: "第5话 家庭会议", number: 5 },
      { id: "ch6-6", title: "第6话 王国庆典", number: 6 },
    ],
  },
  {
    id: "comic-7",
    title: "恶灵学堂",
    author: "尹智勋",
    category: "horror",
    categoryName: "恐怖惊悚",
    cover: "https://readdy.ai/api/search-image?query=A%20chilling%20Korean%20manhwa%20horror%20cover%20art%20showing%20a%20creepy%20abandoned%20school%20corridor%20with%20a%20shadowy%20figure%20looming%20at%20the%20end%2C%20eerie%20greenish%20dim%20lighting%2C%20flickering%20fluorescent%20lights%2C%20distressed%20texture%2C%20psychological%20horror%20atmosphere%2C%20detailed%20environment%20with%20broken%20windows%20and%20peeling%20walls%2C%20mature%20horror%20manga%20style%2C%20professional%20horror%20cover%20quality%2C%20unsettling%20composition&width=800&height=1100&seq=manhwa-cover-07&orientation=portrait",
    description: "在一所废弃多年的高中里，每到午夜就会传出诡异的读书声。一群喜欢探险的大学生决定进入这所学校一探究竟，却发现自己踏入了一个无法逃脱的噩梦。每个教室都隐藏着恐怖的秘密，而最大的恐惧来源于他们在镜子里看到的——竟然不是自己的倒影。",
    rating: 4.3,
    views: 1230000,
    tags: ["恐怖", "校园", "灵异", "惊悚"],
    status: "连载中",
    updatedAt: "2026-08-01",
    chapters: [
      { id: "ch7-1", title: "第1话 午夜钟声", number: 1 },
      { id: "ch7-2", title: "第2话 废校探险", number: 2 },
      { id: "ch7-3", title: "第3话 三楼的哭声", number: 3 },
      { id: "ch7-4", title: "第4话 镜中之人", number: 4 },
      { id: "ch7-5", title: "第5话 无法离开", number: 5 },
    ],
  },
  {
    id: "comic-8",
    title: "长安妖事录",
    author: "柳夏恩",
    category: "historical",
    categoryName: "古风穿越",
    cover: "https://readdy.ai/api/search-image?query=An%20elegant%20Korean%20manhwa%20historical%20fantasy%20cover%20art%20showing%20a%20beautiful%20female%20exorcist%20in%20traditional%20hanbok%20with%20flowing%20sleeves%20surrounded%20by%20ethereal%20spirit%20foxes%20and%20floating%20lanterns%2C%20ancient%20Korean%20palace%20architecture%20in%20background%2C%20mystical%20atmosphere%20with%20soft%20moonlight%2C%20traditional%20ink%20wash%20painting%20aesthetic%20blended%20with%20manga%20style%2C%20professional%20historical%20fantasy%20cover%20quality%2C%20refined%20composition&width=800&height=1100&seq=manhwa-cover-08&orientation=portrait",
    description: "在唐朝长安城，妖魔横行，人妖共存。少女沈清辞天生拥有一双能看见妖怪的眼睛，被一位神秘的道士收为弟子，学习降妖除魔之术。在一次除妖任务中，她邂逅了化作人形的千年狐妖，一段跨越种族与生死的禁忌之恋悄然展开。",
    rating: 4.8,
    views: 2010000,
    tags: ["古风", "妖怪", "玄幻", "爱情"],
    status: "连载中",
    updatedAt: "2026-08-05",
    chapters: [
      { id: "ch8-1", title: "第1话 妖眼少女", number: 1 },
      { id: "ch8-2", title: "第2话 长安夜市", number: 2 },
      { id: "ch8-3", title: "第3话 狐妖现身", number: 3 },
      { id: "ch8-4", title: "第4话 除妖司", number: 4 },
      { id: "ch8-5", title: "第5话 月下之约", number: 5 },
    ],
  },
  {
    id: "comic-9",
    title: "星际殖民纪元",
    author: "崔承浩",
    category: "scifi",
    categoryName: "科幻未来",
    cover: "https://readdy.ai/api/search-image?query=A%20futuristic%20Korean%20manhwa%20sci-fi%20cover%20art%20showing%20a%20spaceship%20pilot%20in%20sleek%20futuristic%20armor%20looking%20out%20at%20a%20vast%20alien%20planet%20landscape%20with%20twin%20moons%2C%20neon%20accent%20lights%2C%20advanced%20technology%20holograms%2C%20expansive%20space%20colony%20visible%20in%20background%2C%20clean%20sci-fi%20aesthetic%20with%20cool%20silver%20and%20teal%20tones%2C%20detailed%20mechanical%20design%2C%20professional%20sci-fi%20manga%20cover%20quality%2C%20epic%20composition&width=800&height=1100&seq=manhwa-cover-09&orientation=portrait",
    description: "公元2257年，人类已经掌握了星际航行技术，开始在银河系中建立殖民地。年轻的星际探险家金宇宙在一次任务中发现了远古外星文明的遗迹，其中隐藏着能够改变整个银河系命运的惊天秘密。各大势力闻风而动，一场横跨星系的争夺战拉开帷幕。",
    rating: 4.6,
    views: 1450000,
    tags: ["科幻", "太空", "冒险", "机甲"],
    status: "连载中",
    updatedAt: "2026-07-30",
    chapters: [
      { id: "ch9-1", title: "第1话 深空任务", number: 1 },
      { id: "ch9-2", title: "第2话 未知信号", number: 2 },
      { id: "ch9-3", title: "第3话 远古遗迹", number: 3 },
      { id: "ch9-4", title: "第4话 星联会议", number: 4 },
      { id: "ch9-5", title: "第5话 黑船来袭", number: 5 },
      { id: "ch9-6", title: "第6话 遗迹之谜", number: 6 },
    ],
  },
  {
    id: "comic-10",
    title: "月光下的约定",
    author: "林秀晶",
    category: "bl-gl",
    categoryName: "BL/GL",
    cover: "https://readdy.ai/api/search-image?query=A%20delicate%20and%20emotional%20Korean%20BL%20manhwa%20cover%20art%20showing%20two%20young%20men%20standing%20close%20under%20moonlight%20by%20a%20calm%20lake%2C%20tender%20atmosphere%20with%20soft%20silver%20moonlight%20reflecting%20on%20water%2C%20gentle%20expressions%2C%20cherry%20blossom%20trees%20in%20background%2C%20romantic%20and%20melancholic%20mood%2C%20beautiful%20shoujo-ai%20manga%20art%20style%2C%20professional%20BL%20cover%20quality%2C%20intimate%20composition&width=800&height=1100&seq=manhwa-cover-10&orientation=portrait",
    description: "高中生李泰民从小体质虚弱，经常住院。在医院里，他遇见了同样长期住院的钢琴天才郑宇贤。两人在病痛中相互扶持，在月光下许下了「一起活下去」的约定。然而命运弄人，当宇贤的病情突然恶化，泰民必须面对人生中最艰难的抉择。",
    rating: 4.7,
    views: 1670000,
    tags: ["青春", "治愈", "音乐", "校园"],
    status: "已完结",
    updatedAt: "2026-06-15",
    chapters: [
      { id: "ch10-1", title: "第1话 白色病房", number: 1 },
      { id: "ch10-2", title: "第2话 钢琴声", number: 2 },
      { id: "ch10-3", title: "第3话 月下约定", number: 3 },
      { id: "ch10-4", title: "第4话 离别", number: 4 },
      { id: "ch10-5", title: "第5话 永远的乐章", number: 5 },
    ],
  },
  {
    id: "comic-11",
    title: "美食猎人",
    author: "姜东元",
    category: "action",
    categoryName: "动作热血",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20action%20cover%20showing%20a%20chef%20wielding%20cooking%20knives%20in%20battle%20stance%20with%20floating%20ingredients%20and%20flames%2C%20vibrant%20food%20elements%20with%20action%20effects%2C%20restaurant%20kitchen%20battlefield%20background%2C%20intense%20determined%20expression%2C%20bold%20colors%20with%20warm%20orange%20and%20red%20tones%2C%20professional%20shonen%20manga%20cover%20quality%2C%20exciting%20composition&width=800&height=1100&seq=manhwa-cover-11&orientation=portrait",
    description: "在这个世界上，存在着被称为「传说食材」的神秘食材，据说食用后能获得超凡的力量。天才厨师韩光烈为了寻找这些传说食材，踏上了横跨全球的美食冒险之旅。他手中的厨刀不仅是烹饪工具，更是对抗美食猎人的武器！",
    rating: 4.5,
    views: 980000,
    tags: ["美食", "冒险", "战斗", "热血"],
    status: "连载中",
    updatedAt: "2026-07-25",
    chapters: [
      { id: "ch11-1", title: "第1话 传说食材", number: 1 },
      { id: "ch11-2", title: "第2话 美食竞技场", number: 2 },
      { id: "ch11-3", title: "第3话 深海之味", number: 3 },
      { id: "ch11-4", title: "第4话 沙漠中的厨房", number: 4 },
    ],
  },
  {
    id: "comic-12",
    title: "总裁的契约新娘",
    author: "金美英",
    category: "romance",
    categoryName: "恋爱言情",
    cover: "https://readdy.ai/api/search-image?query=A%20glamorous%20Korean%20manhwa%20romance%20cover%20showing%20an%20elegant%20woman%20in%20a%20stunning%20wedding%20dress%20standing%20next%20to%20a%20tall%20handsome%20CEO%20in%20a%20luxurious%20penthouse%20setting%2C%20sparkling%20city%20lights%20through%20floor-to-ceiling%20windows%2C%20sophisticated%20and%20dramatic%20atmosphere%2C%20rich%20jewelry%20and%20details%2C%20professional%20romance%20manga%20cover%20quality%2C%20refined%20composition&width=800&height=1100&seq=manhwa-cover-12&orientation=portrait",
    description: "为了拯救父亲的公司，平凡的女孩朴秀雅与掌控韩国半个商业帝国的男人崔振赫签订了一年的契约婚姻。她以为自己只是他商业计划中的一颗棋子，却不知道这场婚姻背后隐藏着崔振赫十年来深藏心底的秘密。契约到期之日，两颗心却已经无法分离。",
    rating: 4.4,
    views: 1980000,
    tags: ["契约", "总裁", "甜蜜", "都市"],
    status: "已完结",
    updatedAt: "2026-05-20",
    chapters: [
      { id: "ch12-1", title: "第1话 一纸契约", number: 1 },
      { id: "ch12-2", title: "第2话 假面夫妻", number: 2 },
      { id: "ch12-3", title: "第3话 心动瞬间", number: 3 },
      { id: "ch12-4", title: "第4话 真相大白", number: 4 },
      { id: "ch12-5", title: "第5话 真爱之约", number: 5 },
    ],
  },
];

export const getComicsByCategory = (slug: string) => {
  return comics.filter(c => c.category === slug);
};

export const getComicById = (id: string) => {
  return comics.find(c => c.id === id);
};

export const getCategoryBySlug = (slug: string) => {
  return categories.find(c => c.slug === slug);
};

export const getHotComics = () => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, 6);
};

export const getLatestUpdates = () => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);
};